module.exports = {"id":"52752","name":"Tranquillo Barnetta","rating":"77","photo":"./data/images/photos/3/52752.png","club":{"name":"FC Saint-Gall","logo":"./data/images/clubs/FCSaint-Gall.png"},"positions":["MOC","MDC","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TranquilloBarnetta0.json
// module id = 4196
// module chunks = 0